import { render } from "./Relatorios.vue?vue&type=template&id=61168324&scoped=true"
import script from "./Relatorios.vue?vue&type=script&lang=js"
export * from "./Relatorios.vue?vue&type=script&lang=js"

import "./Relatorios.vue?vue&type=style&index=0&id=61168324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61168324"]])

export default __exports__